var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'uik-container__wrapper uik-container__wrapper--' + ( _vm.horizontal ? 'horizontal' : 'vertical'),
    {'uik-container__wrapper--centerX': _vm.centerX},
    {'uik-container__wrapper--centerY': _vm.centerY}
]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }